import { render, staticRenderFns } from "./reset_password_component.vue?vue&type=template&id=785fe315&scoped=true&"
import script from "../../assets/customer/js/reset_password.js?vue&type=script&lang=js&"
export * from "../../assets/customer/js/reset_password.js?vue&type=script&lang=js&"
import style0 from "./reset_password_component.vue?vue&type=style&index=0&id=785fe315&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785fe315",
  null
  
)

export default component.exports